import { EdgeMediaQuery, IEMediaQuery, useIsDesktop } from "common/MediaQueries"
import ModelTitleAndImage from "common/ModelTitleAndImage"
import useRedirectIfPreviousComponentsAreNotSelected from "common/useRedirectIfPreviousComponentsAreNotSelected"
import { useLayoutContext } from "layout/oldLayout/LayoutContext"
import styled from "styled-components"
import SelectedDetailingDetails from "../detailing/SelectedDetailingDetails"
import PollutionAndSafety from "../wizard/pollutionAndSafety/PollutionAndSafety"
import Disclaimer from "./Disclaimer"
import LegalNotes from "./LegalNotes"
import { HEIGHT as PurchaseButtonBoxHEIGHT } from "./PurchaseButtonBox"
import PurchaseTools from "./PurchaseTools"
import SendToMailButton from "./SendToMailButton"
import ShareButton from "./ShareButton"
import SummaryButtons from "./SummaryButtons"
import SummaryGallery from "./SummaryGallery"
import PriceDetails from "./priceDetails/PriceDetails"

const StyledContentContainer = styled.div`
  min-height: calc(100% - ${PurchaseButtonBoxHEIGHT}px);
  display: flex;
  flex-direction: column;

  ${(p) => p.theme.breakpoints.up("md")} {
    padding-bottom: 30px;
  }

  // Keeping for historical purposes in case we need them later
  // ${IEMediaQuery} {
  //   padding-bottom: calc(
  //     ${(p) => p.theme.spacing(2)}px + ${PurchaseButtonBoxHEIGHT}px
  //   );
  // }
  // ${EdgeMediaQuery} {
  //   padding-bottom: calc(
  //     ${(p) => p.theme.spacing(2)}px + ${PurchaseButtonBoxHEIGHT}px
  //   );
  // }
`

const StyledPurchaseTools = styled(PurchaseTools)`
  margin-top: 40px;
`

const StyledShareButton = styled(ShareButton)`
  margin-bottom: 20px;
`

const StyledSummaryGallery = styled(SummaryGallery)`
  margin: 20px 0;
`

const StyledLegalNotes = styled(LegalNotes)`
  padding-right: 10px;
  margin-bottom: 30px;
`

const StyledSummaryButtons = styled(SummaryButtons)`
  margin-top: 40px;
`

const SummarySidebar = () => {
  useRedirectIfPreviousComponentsAreNotSelected()
  const { isShowRoomsScreens } = useLayoutContext()
  const isDesktop = useIsDesktop()

  return (
    <>
      <StyledContentContainer>
        {isDesktop && (
          <>
            <Disclaimer />
            <PriceDetails />
            {!isShowRoomsScreens && (
              <>
                <StyledSummaryButtons />
                <StyledPurchaseTools />
              </>
            )}
          </>
        )}

        {!isDesktop && (
          <>
            <ModelTitleAndImage />
            <StyledShareButton />
            <Disclaimer />
            <PriceDetails />
            <PurchaseTools />
            <StyledSummaryGallery />
            <SelectedDetailingDetails hasBackground={true} />
            <StyledLegalNotes />
            <PollutionAndSafety invertColor={false} />
            <StyledSummaryButtons />
          </>
        )}

        {isShowRoomsScreens && <SendToMailButton />}
      </StyledContentContainer>

      {/* <Share /> */}
      {/* <LegalNotes /> */}
      {/* <SelectedComponents /> */}
      {/* {isDesktop && <PurchaseButtonBox />} */}
    </>
  )
}

export default SummarySidebar
